export enum SegmentsForm {
    Segments = 'segments',
}

export const defaultTitle = 'REVIEWS.SEGMENTS.TITLE';
